var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9 6.6V1.5H16.1V6.6H5.9ZM20 6.6H17.6V0.5C17.6 0.223858 17.3761 0 17.1 0H4.9C4.62386 0 4.4 0.223858 4.4 0.500001V6.6H2C0.895431 6.6 0 7.49543 0 8.6V15.6C0 16.7046 0.89543 17.6 2 17.6H5.5V21.5C5.5 21.7761 5.72386 22 6 22H16C16.2761 22 16.5 21.7761 16.5 21.5V17.6H20C21.1046 17.6 22 16.7046 22 15.6V8.6C22 7.49543 21.1046 6.6 20 6.6ZM16.5 16.1H20C20.2761 16.1 20.5 15.8761 20.5 15.6V8.6C20.5 8.32386 20.2761 8.1 20 8.1H2C1.72386 8.1 1.5 8.32386 1.5 8.6V15.6C1.5 15.8761 1.72386 16.1 2 16.1H5.5V13.7C5.5 13.4239 5.72386 13.2 6 13.2H16C16.2761 13.2 16.5 13.4239 16.5 13.7V16.1ZM15 20.5H7V14.7H15V20.5Z",
    fill: "#63666A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintGrey);
export default __webpack_public_path__ + "static/media/PrintGrey.f26442ef1a209c78984cba981f9e7282.svg";
export { ForwardRef as ReactComponent };